// Shared design tokens for Chain Settings V2
// Aligned with Ovio brand: #0095da blue base, translucent white overlays

export const T = {
  // Base brand
  ovioBg: '#0095da',

  // Card backgrounds — translucent white on Ovio blue (matches other portals)
  card: 'rgba(255, 255, 255, 0.08)',
  cardStrong: 'rgba(255, 255, 255, 0.12)',
  cardHover: 'rgba(255, 255, 255, 0.16)',

  // Accent colors — soft, muted tones that work on Ovio blue
  accent: '#fff',
  green: 'rgba(255, 255, 255, 0.85)',
  red: 'rgba(255, 255, 255, 0.6)',
  orange: 'rgba(255, 255, 255, 0.6)',
  cyan: 'rgba(255, 255, 255, 0.85)',

  // Text
  textPrimary: '#fff',
  textSecondary: 'rgba(255, 255, 255, 0.85)',
  textMuted: 'rgba(255, 255, 255, 0.85)',

  // Input styles
  inBg: 'rgba(0, 0, 0, 0.15)',
  inBdr: 'rgba(255, 255, 255, 0.25)',

  // Borders
  border: 'rgba(255, 255, 255, 0.15)',
  borderLight: 'rgba(255, 255, 255, 0.08)',

  // Spacing
  radius: 8,
  radiusSm: 4,

  // Background — the Ovio blue, matching the rest of the app
  bgGradient: '#0095da',
};

export var inputStyle = {
  backgroundColor: T.inBg,
  fontSize: 14,
  color: T.textPrimary,
  borderRadius: T.radiusSm,
  height: 42,
  border: '1px solid ' + T.inBdr,
  width: '100%',
  paddingLeft: 12,
};

export var selectStyle = {
  backgroundColor: T.inBg,
  fontSize: 14,
  color: T.textPrimary,
  borderRadius: T.radiusSm,
  height: 42,
  border: '1px solid ' + T.inBdr,
  width: '100%',
  paddingLeft: 12,
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  appearance: 'none',
  backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'8\' viewBox=\'0 0 12 8\'%3E%3Cpath fill=\'rgba(255,255,255,0.7)\' d=\'M6 8L0 0h12z\'/%3E%3C/svg%3E")',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 12px center',
  paddingRight: 32,
  cursor: 'pointer',
};

export var placeholderColor = 'rgba(255, 255, 255, 0.4)';

export var inputLabelStyle = {
  color: T.textSecondary,
  fontSize: 13,
  marginBottom: 4,
  fontWeight: 500,
};

export var cardStyle = {
  backgroundColor: T.card,
  borderRadius: T.radius,
  border: '1px solid ' + T.border,
  padding: 24,
};

// Tags use subtle white-based styling — no bright colors
export var tagStyle = function (variant) {
  if (variant === 'active') {
    return {
      display: 'inline-block',
      padding: '3px 10px',
      borderRadius: 20,
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: 0.3,
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      color: '#fff',
      border: '1px solid rgba(255, 255, 255, 0.3)',
    };
  }
  if (variant === 'pending') {
    return {
      display: 'inline-block',
      padding: '3px 10px',
      borderRadius: 20,
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: 0.3,
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
      color: 'rgba(255, 255, 255, 0.6)',
      border: '1px solid rgba(255, 255, 255, 0.15)',
    };
  }
  // default / info
  return {
    display: 'inline-block',
    padding: '3px 10px',
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 0.3,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    color: 'rgba(255, 255, 255, 0.8)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
  };
};

export var statCardStyle = {
  backgroundColor: T.cardStrong,
  borderRadius: T.radius,
  border: '1px solid ' + T.border,
  padding: '20px 24px',
  flex: '1 1 0',
  minWidth: 0,
};
